import { render } from "./NewLayoutModal.vue?vue&type=template&id=65a19704&scoped=true"
import script from "./NewLayoutModal.vue?vue&type=script&lang=js"
export * from "./NewLayoutModal.vue?vue&type=script&lang=js"

import "./NewLayoutModal.vue?vue&type=style&index=0&id=65a19704&lang=scss&scoped=true"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a19704"]])

export default __exports__